import { Loader } from '@elearning-platform/ui';
import React from 'react';

import { useVolatileSettings } from '../../hooks';
import { UseVolatileSettings } from '../../interfaces';

import { Wrapper } from './appLoadingScreen.styled';

export const AppLoadingScreen: React.FC = (): JSX.Element | null => {
  const { volatileSettings }: UseVolatileSettings = useVolatileSettings();

  if (!volatileSettings.isAppLoadingVisible) {
    return null;
  }

  return (
    <Wrapper>
      <Loader />
    </Wrapper>
  );
};
